<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX18mNZfCw+h/T4tq+kL/9bZdhpyU4FcT/1o=",
    "cpf": "U2FsdGVkX18j6itDyfFSCtjOLNYjOxvC2u3N3I/Kh+M="
  },
  {
    "num_cand": "U2FsdGVkX1/vV0121+gUQWz8hp+hZ+JnwCQc0NOsD6U=",
    "cpf": "U2FsdGVkX1/2T9fB7ygsO1muXD9sDyAEjlGgP/3ICLA="
  },
  {
    "num_cand": "U2FsdGVkX18yjWDDMlHPZH3InCgXTpTp5TGRz0TsOXw=",
    "cpf": "U2FsdGVkX1891zrIG9NH/cLdHY0U52H92OzJMuKpNz8="
  },
  {
    "num_cand": "U2FsdGVkX19/I3pr+QIWF8WiwLS4+aeAZfGZWcMPY9U=",
    "cpf": "U2FsdGVkX1/GKYaEBZSRRy2lOWoPhlfW6trc1PK///k="
  },
  {
    "num_cand": "U2FsdGVkX19O+YJ1bMjVViQj/6Qf6xbXH7/y+n3zFPc=",
    "cpf": "U2FsdGVkX1+awoRUXKob5oLVPIIM9AjF5GoKSMknJRY="
  },
  {
    "num_cand": "U2FsdGVkX18Mik61FFI1MG3O8pzBorwzc2Q7sMPcVss=",
    "cpf": "U2FsdGVkX1/o3GIttwemSS1eyBdbcCA0UVgz4n/N6BQ="
  },
  {
    "num_cand": "U2FsdGVkX18KUV9ggwnEsacNIBriuDbvBI0tgYuA1QE=",
    "cpf": "U2FsdGVkX1/G331fdn/QdhLg0MEj5TO+v0bfaMiE5B4="
  },
  {
    "num_cand": "U2FsdGVkX191AI0HpaIqfrPitAGITk4jVYS2J5tEPLQ=",
    "cpf": "U2FsdGVkX192tjfEzksN5HpP2sHqaENTxf5LQtsIVWk="
  },
  {
    "num_cand": "U2FsdGVkX18W+X4Cuq2t3I+LVrexr9ZqV6mXhtj5ekU=",
    "cpf": "U2FsdGVkX1+ik8BZmFcXuXv/gIGD5MoZphJ6LEBbHdE="
  },
  {
    "num_cand": "U2FsdGVkX1930KOrN48JyJRR+f10ZxxxN7xZ3FHPHaQ=",
    "cpf": "U2FsdGVkX1+CCDMUy+MNhrxsbfONv0QpzQR9ePxzBVk="
  },
  {
    "num_cand": "U2FsdGVkX19xMYH4PHQ65XrTiLS4k7KWzwyQpkfNkXE=",
    "cpf": "U2FsdGVkX189zVXvyx3rO9rnoBP7xX45tP92+s6kffU="
  },
  {
    "num_cand": "U2FsdGVkX1+qF3T2CtrIxNU5q3zZo8x5B5Jghl5Ym6g=",
    "cpf": "U2FsdGVkX19ENW4cUyih+72nyyyxEkfthnJr0poGPic="
  },
  {
    "num_cand": "U2FsdGVkX1+BmWCy7GwtJa4wsiR/uc8TD6nxwQF6u00=",
    "cpf": "U2FsdGVkX1/lex4KFw3EXEBugXUuFa4kDCNigT+eUtk="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2112/2112_rec_isc/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
